import type { ZabitBridge } from '../../renderer/src/global';

/**
 * Paylaş menüsünden gelen ses dosyası — yalnızca mobil uygulamada
 * (mobile/src/shims/sharedAudio.ts). Web'de dosya "Ses dosyası yükle"den seçiliyor.
 */
export const sharedAudio: ZabitBridge['sharedAudio'] = undefined;
